/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import SmartsRecommenderService from './SmartsRecommenderService';

class SmartsPredictRecommenderService extends SmartsRecommenderService{

	constructor(options) {
		super(options);
	}

	/**
	 * Fetch prediction recommendations so called default scope
	 * @param {Object} options including moduleAPI and targetId
	 * @returns {Promise} promise object represents array of recommendations
	 */
	fetchPredictRecommendations(options) {
		const PREDICT_RECOMMENDATIONS_URL = 'v1/predict/recommendations';
		return this._getRequestParameters(options)
			.then((requestParams) => this._executeRequest(requestParams, PREDICT_RECOMMENDATIONS_URL))
			.then(this._processPredictRecommendationsData.bind(this));
	}

	_isSucessful(response) {
		return response.predictStatus.state === 'SUCCESS';
	}

	_processPredictRecommendationsData(ajaxResponse){
		const recommenderResponse = ajaxResponse.data;
		if (this._isSucessful(recommenderResponse)) {
			return recommenderResponse.results.recommendedFields.fields;
		} else {
			this.logger.debug(ajaxResponse);
			return [];
		}
	}

	_getRequestParameters (options) {
		const moduleAPI = options.moduleAPI;
		const tempModule = moduleAPI.getTemporarySessionModuleJSON();
		const requestParameters = {
			targetFieldIDForExpression: options.targetId,
			moduleId: moduleAPI.getAssetId(),
			shapedModule: (!!moduleAPI.getShapingId()),
			tuningParams: {
				allowCategoryTarget: true,
				noCorrelationLimit: true
			}
		};
		if (tempModule) {
			requestParameters.tempModule = JSON.stringify(tempModule);
		}
		return moduleAPI.saveTemporaryModule()
			.then((shapingModuleId) => {
				if (moduleAPI.getAssetId() !== shapingModuleId) {
					requestParameters.tempModuleId = shapingModuleId;
				}
				return requestParameters;
			});
	}
}
export default SmartsPredictRecommenderService;



// WEBPACK FOOTER //
// ./src/js/util/SmartsPredictRecommenderService.js